import React from 'react'
import PropTypes from 'prop-types'
import FilterModal from 'components/FilterModal'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'
import { FilterGroup } from 'components/common/Filters/FilterGroup'

const GlobalSearchFilterModal = ({
  filters,
  selectedFilters,
  handleSubmit,
  handleFilterClear,
  handleFilterRemove,
  handleFilterChange
}) =>
  <FilterModal onSubmit={ handleSubmit }>
    <FilterBreadcrumbs
      selectedFilters={ selectedFilters }
      onFilterClear={ handleFilterClear }
      onFilterRemove={ handleFilterRemove } />
    {
      filters.map(({ displayName, refinements = []}) =>
        <FilterGroup
          key={ displayName }
          title={ displayName }
          refinements={ refinements }
          onChange={ handleFilterChange } />
      )
    }
  </FilterModal>

GlobalSearchFilterModal.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string,
    refinements: PropTypes.array
  })),
  handleFilterChange: PropTypes.func,
  handleFilterClear: PropTypes.func,
  handleFilterRemove: PropTypes.func,
  handleSubmit: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(PropTypes.object)
}

export default GlobalSearchFilterModal
